import api from "../../common/tools/axios";

// Which LLM runs the user's AI calls. The listing is availability-filtered
// server-side: a provider with no API key, or one whose circuit breaker tripped
// because its account ran out of credit, is simply absent — the picker never
// offers a choice that cannot run.

const getModels = () => {
  return api.get('/generator/llm/models')
    .then((response) => response.data || response);
};

const getPreference = () => {
  return api.get('/generator/llm/preference')
    .then((response) => response.data || response);
};

// `model` is a model id from getModels(); '' clears the pin and falls back to
// the platform default.
const setPreference = (model) => {
  return api.post('/generator/llm/preference', { model })
    .then((response) => response.data || response);
};

const LLMService = {
  getModels,
  getPreference,
  setPreference,
};

export default LLMService;
